<script>
import { StatisticSeries } from '@/vue-prop-types/Statistics'

export default {
  props: {
    entries: { type: StatisticSeries, default: () => [] },
  },
  computed: {
    convertedString() {
      return `data:text/csv;charset=utf-8,${this.csv.join('\n')}`
    },
    csv() {
      return [this.header, ...this.rows]
    },
    header() {
      return ['', ...this.entries.dataSets.map((set) => set.legend || '')]
    },
    rows() {
      const rows = []
      for (let i = 0; i < this.entries.yAxisLabels.length; i++) {
        rows.push([
          this.entries.labels[i],
          ...this.entries.dataSets.map((set) => set.dataPoints[i]),
        ])
      }
      return rows
    },
  },
  render() {
    return this.$slots.default({
      convertedString: this.convertedString,
    })
  },
}
</script>
